module.exports = __webpack_public_path__ + "img/Gaibom.74e6a1df.svg";